import { createSlice } from "@reduxjs/toolkit";
import { ApiCallStatus, ApiResourceState, Resource, ResourceList } from "@myRedux/networkState";
import { RootState } from "@myRedux/store";
import { handleSliceRejectionDefault } from "@myRedux/handleSliceRejection";
import { getResourceFromRel } from "@myRedux/appAsyncThunkUtilities";

export interface StateResource extends Resource {
  stateId: string,
  name: string,
  shortName: string
}

const initialState = {
  status: ApiCallStatus.Idle,
  value: null
} as ApiResourceState<ResourceList<StateResource>>;

export const getStatesAsync = getResourceFromRel(
  'state/getStates',
  'states')

export const stateSlice = createSlice({
  name: 'stateSlice',
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getStatesAsync.pending, (state) => {
        state.status = ApiCallStatus.Loading;
      })
      .addCase(getStatesAsync.fulfilled, (state, action) => {
        state.status = ApiCallStatus.Succeeded;
        state.value = action.payload;
      })
      .addCase(getStatesAsync.rejected, (state, action) => {
        state.status = ApiCallStatus.Failed;
        state.value = null;
        handleSliceRejectionDefault(action);
      });
  },
});

export const selectStates = (state: RootState) => state.state.states;

export default stateSlice.reducer;